import {
  ContentBlock,
  Heading,
  Stack,
  Columns,
  Column,
  Box,
  Strong,
  Text,
  Inline,
} from 'braid-design-system';
import React, { type ReactNode } from 'react';
import parseHtml from 'react-html-parser';

import { encodeSvg } from 'src/shared/helpers';

interface Props {
  title: string;
  children: ReactNode;
  icons: any[];
  reverse?: boolean;
}

export const RealReviews = ({ title, children, icons }: Props) => (
  <ContentBlock>
    <Box paddingX={{ mobile: 'small', desktop: 'none' }}>
      <Columns
        collapseBelow="tablet"
        space={['large', 'xlarge']}
        alignY="center"
      >
        <Column width="1/2">
          <Box style={{ maxWidth: '460px' }}>
            <Stack space="large">
              <Box
                textAlign={{
                  mobile: 'center',
                  desktop: 'left',
                  tablet: 'left',
                }}
              >
                <Heading level="2">
                  <Strong>{title}</Strong>
                </Heading>
              </Box>
              <>{children}</>
            </Stack>
          </Box>
        </Column>
        <Column width="1/2">
          <Stack space="small">
            {icons.map((obj: any, key: number) => (
              <Box
                padding="small"
                paddingX={{ mobile: 'medium', desktop: 'gutter' }}
                key={key}
                borderRadius="large"
                boxShadow="borderNeutralLight"
              >
                <Inline
                  space={{
                    mobile: 'medium',
                    tablet: 'small',
                    desktop: 'medium',
                  }}
                  alignY="center"
                >
                  <Box
                    style={{
                      width: '72px',
                      maxWidth: '128px',
                      height: '72px',
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50%',
                      backgroundImage: encodeSvg(obj.icon),
                    }}
                  />
                  <Box>
                    <Text size="large">{parseHtml(obj.text)}</Text>
                  </Box>
                </Inline>
              </Box>
            ))}
          </Stack>
        </Column>
      </Columns>
    </Box>
  </ContentBlock>
);
